export default "__VITE_ASSET__87c74e51__"